import { render, staticRenderFns } from "./ViewArticles.vue?vue&type=template&id=1d148de2&scoped=true"
import script from "./ViewArticles.vue?vue&type=script&lang=js"
export * from "./ViewArticles.vue?vue&type=script&lang=js"
import style0 from "./ViewArticles.vue?vue&type=style&index=0&id=1d148de2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d148de2",
  null
  
)

export default component.exports